import { __decorate, __metadata } from "tslib";
import { WeekDayEnum } from '@goparrot/common';
import { Expose, Type } from 'class-transformer';
import { ArrayMinSize, IsArray, IsEnum, IsInt, IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';
import { LoyaltyProgramExposeGroupEnum, TimeframeTypeEnum } from '../interface';
import { ReadAbstractTimeframeDto } from './ReadAbstractTimeframeDto';
import { ReadTimeRangeDto } from './ReadTimeRangeDto';
export class ReadTimeframeWeeklyDto extends ReadAbstractTimeframeDto {
}
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    IsEnum(TimeframeTypeEnum, { always: true }),
    __metadata("design:type", String)
], ReadTimeframeWeeklyDto.prototype, "type", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], ReadTimeframeWeeklyDto.prototype, "title", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    IsInt({ always: true }),
    __metadata("design:type", Number)
], ReadTimeframeWeeklyDto.prototype, "priority", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsString({ always: true, each: true }),
    IsArray({ always: true }),
    __metadata("design:type", Array)
], ReadTimeframeWeeklyDto.prototype, "locations", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], ReadTimeframeWeeklyDto.prototype, "messagePromo", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], ReadTimeframeWeeklyDto.prototype, "messageOrderFinalize", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsArray({ always: true }),
    IsEnum(WeekDayEnum, { always: true, each: true }),
    ArrayMinSize(1, {
        groups: [LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT],
        message: 'Please select at least one day',
    }),
    __metadata("design:type", Array)
], ReadTimeframeWeeklyDto.prototype, "weekdays", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsArray({ always: true }),
    ValidateNested({ always: true, each: true }),
    Type(() => ReadTimeRangeDto),
    __metadata("design:type", Array)
], ReadTimeframeWeeklyDto.prototype, "timeRange", void 0);
//# sourceMappingURL=ReadTimeframeWeeklyDto.js.map